<page-headline
    [linkTitle]="'Historical Trends Home'"
    [module]="'historical-trends'"
    [moduleIcon]="'fa-chart-line'"
    [moduleLink]="'historical-trends'"
    [pageTitle]="pageTitle"
>
</page-headline>
<div class="historical-trend-container">
    <div class="historical-trend-control-area">
        <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
        <div class="displayopt-actionpanel-layout">
            <display-options (displayOptionsOutput)="applyDisplayOptions($event)">
            </display-options>
            <action-panel
                [showExportCsv]="false"
                [showSaveAsPdf]="true"
                [showPrint]="false"
                [title]="pageTitle"
            >
            </action-panel>
        </div>
        <year-toggle
            [year]="yearOption.year"
            [color]="colorOptions[yearOption.yearInfo.index]"
            [visible]="yearOption.yearInfo.visible"
            *ngFor="let yearOption of yearOptions.slice().reverse()"
            (click)="toggleYear(yearOption.year, yearOption.yearInfo.visible)"
        ></year-toggle>
    </div>
    <div class="row-layout-track">
        <div *ngFor="let cardId of largeCardIdArray" class="largecard-layout-box__50">
            <ng-template customDashboardsOutlet [item]="cardId"></ng-template>
        </div>
    </div>
</div>
